export default __webpack_public_path__ + "static/residential-lettings-9ca339b065c8a7da8af917bb0a912633.png";